import app from '../app';
import { inputOfferPrice, changeUserGeo, loadPublishTerms, updateOffer, needIdentification, publishToHiddenBase } from '../../../../shared/redux/reducers';
import { changeSavedOffer } from '../../../../shared/redux/reducers';
import { changeUser } from '../../../../shared/redux/reducers';
import { changeDictionaryCountryCodes, changeDictionaryRegions } from '../../../../shared/redux/reducers';
import { shouldLoadPublishTermsAfterOfferUpdate } from '../utils';
import { clone, path, omit, equals } from 'ramda';
import { selectActiveCalltrackingPeriod } from '../../../../shared/selectors/calltracking';
import { getPhone } from '../../../../shared/utils';

const getPrice = offer => path(['bargainTerms', 'price'], offer);

export function rootScopeWatcherService(
  $rootScope,
  store,
  geoService,
  placingTermsApi,
  $timeout,
  addFormService,
  pubAvailService,
  hiddenBaseService,
  publishTermsService,
) {
  'ngInject';

  return {
    init: () => {
      /* ВАЖНО: Не нужно здесь отправлять экшены в стор для первого сохранения данных,
          поскольку вотчеры в функции subscribe вызывают свои листенеры первый раз при инициализации. */
    },
    subscribe: () => {
      $rootScope.$watch(() => $rootScope.ad, (offer, prevOffer) => {
        store.dispatch(updateOffer(clone(offer)));

        const isFirstCall = offer === prevOffer;
        const shouldLoadPublishTerms = shouldLoadPublishTermsAfterOfferUpdate(offer, prevOffer);
        const isPriceChanged = getPrice(offer) !== getPrice(prevOffer);

        if (isFirstCall || shouldLoadPublishTerms) {
          store.dispatch(loadPublishTerms());
        }

        if (isPriceChanged) {
          store.dispatch(inputOfferPrice());
        }
      }, true);

      $rootScope.$watch(() => $rootScope.countryCodes, (countryCodes) => {
        store.dispatch(changeDictionaryCountryCodes(clone(countryCodes)));
      }, true);

      $rootScope.$watch(() => $rootScope.regions, (regions) => {
        store.dispatch(changeDictionaryRegions(clone(regions)));
      }, true);

      $rootScope.$watch(() => $rootScope.savedAd, (savedOffer) => {
        store.dispatch(changeSavedOffer(clone(savedOffer)));
      }, true);

      $rootScope.$watch(() => $rootScope.user, (user) => {
        store.dispatch(changeUser(clone(user)));
      }, true);

      $rootScope.$watch(() => geoService.userGeo, (userGeo) => {
        store.dispatch(changeUserGeo(clone(userGeo)));
      }, true);

      $rootScope.$watch(
        /* если isAvailable == undefined - запрос доступности публикации еще не начался,
           либо в процессе => идентификация не нужна */
        () => pubAvailService.isAvailable === false,
        isNeedIdentification => {
          store.dispatch(needIdentification(isNeedIdentification));
        },
      );

      $rootScope.$watch(() => !!hiddenBaseService.isEnabled(), (isHiddenBaseEnabled) => {
        store.dispatch(publishToHiddenBase(isHiddenBaseEnabled));
      });

      store.subscribe(() => {
        if (!publishTermsService.isNewPublishTermsEnabled()) {
          return;
        }

        const state = store.getState();
        const {
          calltracking: { isAvailable, isEnabled },
        } = state;

        const calltracking = omit(['selectedPeriod'], placingTermsApi.calltrackingOption);

        let shouldApply = false;

        // Синхронизируем изменения колтрекинга
        if (!equals(calltracking, state.calltracking)) {
          const selectedPeriod = { ...selectActiveCalltrackingPeriod(state) };
          const calltrackingOption = { ...state.calltracking, selectedPeriod };

          placingTermsApi.calltrackingOption = calltrackingOption;
          placingTermsApi.isCalltrackingAvailable = isAvailable;
          placingTermsApi.selectAdditional(calltrackingOption);
          placingTermsApi.isCalltrackingSelected = () => isEnabled;

          if (isEnabled && !addFormService.ad.replacedPhone) {
            const phones = addFormService.ad.phones || [];

            addFormService.ad.replacedPhone = getPhone(phones[0]);
          }

          shouldApply = true;
        }

        if (shouldApply) {
          // Ждем пока закончится текущий digest cycle ангуляра и говорим ему что состояние обновилось
          $timeout(() => {
            $rootScope.$apply();
          });
        }
      });
    },
  };
}

app.factory('ngStoreToReduxMergeService', rootScopeWatcherService);
